import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '@services/api';
import type { BehaviourType } from './types';

const useGetBehaviours = () => {
  const [behaviours, setBehaviours] = useState<BehaviourType[]>([]);
  const [loading, setLoading] = useState(true);

  const getBehaviours = async () => {
    setLoading(true);
    try {
      const response = await api.get('/disposition_option/behaviour');
      setBehaviours(response.data);
    } catch {
      toast.error('Erro ao carregar os comportamentos. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBehaviours();
  }, []);

  return {
    behaviours,
    loading,
  };
};

export default useGetBehaviours;
